import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  LayoutDashboard,
  Building2,
  Users,
  MessageSquare,
  FileText,
  Star,
  CreditCard,
  BarChart3,
  Send,
  LogOut,
  ArrowLeft
} from 'lucide-react';
import './admin.css';
import { COLORS } from '../theme/colors';

const navItems = [
  { path: '/admin', icon: LayoutDashboard, label: 'Dashboard', exact: true },
  { path: '/admin/workspaces', icon: Building2, label: 'Workspaces' },
  { path: '/admin/users', icon: Users, label: 'Users' },
  { path: '/admin/chats', icon: MessageSquare, label: 'Chats' },
  { path: '/admin/documents', icon: FileText, label: 'Documents' },
  { path: '/admin/feedbacks', icon: Star, label: 'Feedbacks' },
  { path: '/admin/payments', icon: CreditCard, label: 'Payments' },
  { path: '/admin/shares', icon: Send, label: 'Shares' },
  { path: '/admin/blog-analytics', icon: BarChart3, label: 'Blog Analytics' },
];

export function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleBackToApp = () => {
    navigate('/');
  };

  return (
    <div className="admin-container">
      <aside className="admin-sidebar">
        <div style={{ padding: '20px', borderBottom: `1px solid ${COLORS.ink700}` }}>
          <h1 style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>Admin Panel</h1>
          <p style={{ fontSize: 12, color: 'var(--text-disabled)', marginTop: 4 }}>{user?.email}</p>
        </div>

        <nav style={{ padding: '16px 0' }}>
          {navItems.map(({ path, icon: Icon, label, exact }) => (
            <NavLink
              key={path}
              to={path}
              end={exact}
              style={({ isActive }) => ({
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: '12px 20px',
                color: isActive ? 'white' : 'var(--text-disabled)',
                backgroundColor: isActive ? 'var(--ink-700)' : 'transparent',
                textDecoration: 'none',
                transition: 'all 0.2s'
              })}
            >
              <Icon size={20} />
              {label}
            </NavLink>
          ))}
        </nav>

        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: 16, borderTop: `1px solid ${COLORS.ink700}` }}>
          <button
            onClick={handleBackToApp}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              width: '100%',
              padding: '10px 12px',
              marginBottom: 8,
              background: 'var(--ink-700)',
              border: 'none',
              borderRadius: 6,
              color: 'white',
              cursor: 'pointer'
            }}
          >
            <ArrowLeft size={18} />
            Back to App
          </button>
          <button
            onClick={handleLogout}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              width: '100%',
              padding: '10px 12px',
              background: 'transparent',
              border: `1px solid ${COLORS.ink700}`,
              borderRadius: 6,
              color: 'var(--text-disabled)',
              cursor: 'pointer'
            }}
          >
            <LogOut size={18} />
            Logout
          </button>
        </div>
      </aside>

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
